<template>
  <div style="position: absolute;width: 100% !important">
    <!-- Header -->
    <header class="site-header header-s1 is-sticky">
      <!-- Navbar -->
      <Menu />
      <!-- #end Navbar -->
    </header>
    <!-- End Header -->

    <div class="section">
      <div class="container position">
        <div class="position-head">
          <h1 class="job_title">{{ opening.role_name }}</h1>
          <p class="job_location">
            <span v-for="(location, index) in opening.locations">
              <span v-if="index !== opening.locations.length - 1">
                {{ location.city }},
              </span>
              <span v-else>
                {{ location.city }}
              </span>
            </span>
          </p>
        </div>
        <div>
          <br />
          <br />
          <span style="color: #ff0000;">
            <h6><u>Job Status</u>: {{ opening.jobstatus }}</h6>
            <h6><u>Required Skill</u>: {{ opening.requiredskill }}</h6>
            <h6>
              <u>Required Qualification</u>: {{ opening.maj_qualification }}
            </h6>
            <h6><u>Extras</u>: {{ opening.extra_skill }}</h6>
            <h6><u>Job Status</u>: {{ opening.jobstatus }}</h6>
            <h6>
              <u>Application Deadline</u>:
              {{ vacancy ? opening.last_applydate : "Vacancy Expired" }}
            </h6>
            <!-- <h5><u>Hiring Goal</u>: {{opening.available_slots}}.</h5> -->
          </span>
        </div>
        <div class="position-body" v-html="opening.jobdescription"></div>
        <div class="apply" id="apply">
          <h3>Apply for this position</h3>
          <form role="form" v-on:submit.prevent="submitDone" id="input-fields">
            <p>Fields marked <b style="color: #4d4646;">*</b> are required</p>
            <div class="row">
              <div class="col-lg-8 col-md-8 col-sm-12">
                <div class="inputs">
                  <div class="form-group">
                    <label for="firstname">First Name <span>*</span></label>
                    <input
                      type="text"
                      v-model="application.firstname"
                      id="firstname"
                      class="form-control"
                      name="firstname"
                      placeholder="First Name"
                      required="required"
                    />
                  </div>
                  <div class="form-group">
                    <label for="lastname">Last Name <span>*</span></label>
                    <input
                      type="text"
                      v-model="application.lastname"
                      id="lastname"
                      class="form-control"
                      name="lastname"
                      placeholder="Last Name"
                      required="required"
                    />
                    <input
                      type="hidden"
                      v-model="application.company_id"
                      id="company_id"
                      class="form-control"
                      value="opening.company_id"
                    />
                  </div>
                  <div class="form-group">
                    <label for="email">Email <span>*</span></label>
                    <input
                      type="text"
                      v-model="application.emailaddress"
                      id="email"
                      class="form-control"
                      name="email"
                      placeholder="Email"
                      required="required"
                    />
                  </div>
                  <div class="form-group">
                    <label for="phone">Phone <span>*</span></label>
                    <input
                      type="text"
                      pattern="^[0]\d{10}$"
                      v-model="application.phone"
                      id="phone"
                      class="form-control"
                      name="phone"
                      placeholder="Phone"
                      title="Example: 08012345678"
                      maxlength="11"
                      minlength="11"
                      required="required"
                    />
                  </div>
                  <div class="form-group">
                    <label for="age">Age <span>*</span></label>
                    <input
                      type="number"
                      v-model="application.age"
                      id="age"
                      class="form-control"
                      name="age"
                      placeholder="Age"
                      required="required"
                      min="15"
                      max="100"
                    />
                  </div>
                  <div class="form-group">
                    <label for="course">Course <span>*</span></label>
                    <input
                      type="text"
                      v-model="application.course"
                      id="course"
                      class="form-control"
                      name="course"
                      placeholder="Course"
                      required="required"
                    />
                  </div>
                  <div class="form-group">
                    <label for="number"
                      >Level of Educational Qualification</label
                    >
                    <select
                      v-model="application.education"
                      class="form-control"
                    >
                      <option value="B.Sc" selected="selected">B.Sc</option>
                      <option value="BA">BA</option>
                      <option value="B.Ed">B.Ed</option>
                      <option value="B.Eng">B.Eng</option>
                      <option value="HND">HND</option>
                      <option value="National Diploma">National Diploma</option>
                      <option value="SSCE">SSCE</option>
                    </select>
                  </div>
                  <div class="form-group" v-if="application.education == 'HND'">
                    <label for="number">Grade <span>*</span></label>
                    <select
                      v-model="application.grades"
                      class="form-control"
                      required="required"
                    >
                      <option value="Distinction">Distinction</option>
                      <option value="Upper Credit">Upper Credit</option>
                      <option value="Lower Credit">Lower Credit</option>
                      <option value="Pass">Pass</option>
                    </select>
                  </div>
                  <div class="form-group" v-else>
                    <label for="number">Grade <span>*</span></label>
                    <select v-model="application.grades" class="form-control">
                      <option value="First Class">First Class</option>
                      <option value="Second Class Upper"
                        >Second Class Upper</option
                      >
                      <option value="Second Class Lower"
                        >Second Class Lower</option
                      >
                      <option value="Third Class">Third Class</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label for="years_of_experience"
                      >Years of Experience <span>*</span></label
                    >
                    <input
                      type="number"
                      v-model="application.years_of_experience"
                      id="years_of_experience"
                      class="form-control"
                      name="years_of_experience"
                      placeholder="Years of Experience"
                      min="0"
                      max="50"
                      required="required"
                    />
                  </div>
                  <div class="form-group">
                    <label for="current_employer"
                      >Current or Immediate Past Employer</label
                    >
                    <input
                      type="text"
                      v-model="application.current_employer"
                      id="current_employer"
                      class="form-control"
                      name="current_employer"
                      placeholder="Current Employer"
                    />
                  </div>
                  <div class="form-group">
                    <label for="linkedinprofile">LinkedIn Profile</label>
                    <input
                      type="text"
                      v-model="application.linkedinprofile"
                      id="linkedinprofile"
                      class="form-control"
                      name="linkedinprofile"
                      placeholder="https://www.linkedin.com/in/username"
                    />
                  </div>
                  <div class="form-group">
                    <label for="referrer"
                      >How did you hear about this job? <span>*</span></label
                    >
                    <select
                      v-model="application.referrer"
                      id="referrer"
                      class="form-control"
                      name="referrer"
                      required="required"
                    >
                      <option value="job_boards">Online Job Boards</option>
                      <option value="social_media">Social Media</option>
                      <option value="staff"
                        >Current or Past Sundry Staff</option
                      >
                      <option value="linkedin">LinkedIn</option>
                      <option value="sundry_website">Sundry Website</option>
                    </select>
                  </div>
                  <div
                    class="form-group"
                    v-show="application.referrer == 'staff'"
                  >
                    <label for="referrer_name">Staff Name</label>
                    <input
                      type="text"
                      v-model="application.referrer_name"
                      id="referrer_name"
                      class="form-control"
                      name="referrer_name"
                      placeholder="Staff Name"
                      v-bind:required="application.referrer == 'staff'"
                    />
                  </div>
                  <div class="form-group">
                    <label>Cover Letter <span>*</span></label>
                    <summernote :model.sync="application.cover_letter" />
                    <p class="error" v-show="application.no_cover_letter">
                      Your cover letter is required.
                    </p>
                    <p class="error" v-show="application.no_cover_letter">
                      Your cover letter is required.
                    </p>
                  </div>
                  <hr />
                  <div class="dynamic_questions">
                    <div class="form-group" v-for="q in opening.questions">
                      <label
                        >{{ q.question }}
                        <span v-show="q.required == '1'">*</span></label
                      >
                      <textarea
                        style="height: 200px;"
                        class="form-control"
                        v-bind:required="q.required == '1'"
                        v-model="application.answers[q.id]"
                        v-bind:id="q.interview_questions_id"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <input
              v-if="!submitted_form && vacancy"
              type="submit"
              name="submit"
              class="btn btn-md btn-primary"
              value="Next"
            />
            <div class="vld-parent">
              <loading :active.sync="isLoading"></loading>
            </div>
          </form>

          <form
            style="margin-top: 100px;"
            role="form"
            v-on:submit.prevent="submitFiles"
            v-if="submitted_form"
          >
            <h5>Upload FIles:</h5>
            <div class="form-group">
              <label for="cv"
                >Upload CV (PDF, Doc or Docx) Max File Size 4MB
                <span>*</span></label
              >
              <input
                type="file"
                id="cv"
                class="form-control"
                name="cv"
                ref="cv"
                accept=".doc, .docx, .pdf"
                required="required"
              />
            </div>
            <div class="form-group">
              <label for="nysc"
                >Upload NYSC Discharge (PDF, Doc or Docx) Max File Size 4MB
                <span>*</span></label
              >
              <input
                type="file"
                id="nysc"
                class="form-control"
                name="nysc"
                ref="nysc"
                accept=".doc, .docx, .pdf"
                required="required"
              />
            </div>
            <div class="form-group">
              <label for="waec"
                >Upload WAEC Result (PDF, Doc or Docx) Max File Size 4MB
                <span>*</span></label
              >
              <input
                type="file"
                id="waec"
                class="form-control"
                name="waec"
                ref="waec"
                accept=".doc, .docx, .pdf"
                required="required"
              />
            </div>
            <div class="form-group">
              <label for="Undergraduate"
                >Upload Undergraduate Degree or Statement of Result (PDF, Doc or
                Docx) Max File Size 4MB <span>*</span></label
              >
              <input
                type="file"
                id="Undergraduate"
                class="form-control"
                name="Undergraduate"
                ref="undergraduate"
                accept=".doc, .docx, .pdf"
                required="required"
              />
            </div>
            <div class="form-group">
              <label for="other"
                >Others (First School Leaving Certificate) (PDF, Doc or Docx)
                Max File Size 4MB <span>*</span></label
              >
              <input
                type="file"
                id="other"
                class="form-control"
                name="other"
                ref="other"
                accept=".doc, .docx, .pdf"
                required="required"
              />
            </div>
            <div class="form-group">
              <label for="other"
                >Passport Photograph (png,jpg,jpeg,pdf) Max File Size 4MB
                <span>*</span></label
              >
              <input
                type="file"
                id="passport"
                class="form-control"
                name="passport"
                ref="passport"
                accept=".png, .jpg, .jpeg,.pdf"
                required="required"
              />
            </div>
            <div class="vld-parent">
              <loading :active.sync="isLoading"></loading>
              <input
                type="submit"
                name="submit"
                class="btn btn-md btn-primary"
                value="Submit Form"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<style scoped>
.error {
  color: #ff0000;
  font-weight: bold;
}

.form-group label span {
  color: #ff0000 !important;
}

ul li {
  list-style: none !important;
}
</style>

<script>
import Menu from "../components/Menu";
import Footer from "../components/Footer";
import Summernote from "../components/Summernote";
import { router } from "../router";
import swal from "sweetalert2";
import axios from "axios";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "Application",
  data() {
    return {
      error: false,
      applicant_id: "",
      submitted_form: false,
      dis: false,
      isLoading: false,
      fullPage: true,
      loading: 0,
      final_file: false,
      opening: {},
      application: {
        firstname: "",
        lastname: "",
        emailaddress: "",
        phone: "",
        company_id: "",
        age: "",
        document_id: "",
        years_of_experience: "",
        current_employer: "",
        linkedinprofile: "",
        referrer: "",
        education: "",
        referrer_name: "",
        cover_letter: "",
        course: "",
        grades: "",
        joblistingid: this.$route.params.id,
        answers: {},
        no_cover_letter: false,
      },
    };
  },
  mounted() {
    var opening_id = this.$route.params.id;
    this.getOpening(opening_id);
  },
  watch: {
    final_file: function(val) {
      // if(val == true) {
      //   this.submitForm();
      // }
    },
  },
  computed: {
    vacancy() {
      // return true
      // console.log((new Date(this.opening.last_applydate)).getTime())
      // console.log((new Date()).getTime())
      return (
        new Date(this.opening.last_applydate).getTime() >= new Date().getTime()
      );
    },
    // loadingStop () {
    // 	if(this.final_file == true) {
    // 		// this.isLoading = false;
    //     this.submitForm();
    // 		// this.$swal.fire("Success", "Form submitted. Please upload documents.", 'success')
    // 	}
    // 	return this.final_file
    // }
  },

  methods: {
    getOpening: function(opening_id) {
      var get_openings_request = {
        url: "https://sundrymarkets.website/api/findopening/" + opening_id,
        // url: 'https://sundryfoods.website/api/findopening/' + opening_id,
        // url: 'http://127.0.0.1:8000/api/findopening/' + opening_id,
        what: "FindOpening",
      };
      this.$socket
        .makeGetRequest(get_openings_request)
        .then((response) => {
          if (response.type == "FindOpening") {
            // console.log(response.data)
            this.opening = response.data;
            this.application.company_id = response.data.company_id;
          }
        })
        .catch((e) => {
          // console.log(e)
        });
    },

    // async submitFiles() {
    //   this.isLoading = true;

    //   try {
    //     const confirmResponse = await this.$socket.makePostRequest({
    //       what: "ConfirmApplication",
    //       showLoader: false,
    //       data: {
    //         emailaddress: this.application.emailaddress,
    //         joblistingid: this.application.joblistingid,
    //         company_id: this.application.company_id,
    //       },
    //     });
    //     console.log("confirmResponseee:", confirmResponse);
    //     if (
    //       confirmResponse.status == false ||
    //       confirmResponse.data.status == false
    //     ) {
    //       console.log("confirmResponse:", confirmResponse);
    //       this.$swal.fire(
    //         "Already Applied",
    //         confirmResponse.data.message ||
    //           confirmResponse.message ||
    //           "You have already applied for this position with this email address.",
    //         "error",
    //       );
    //       this.isLoading = false;
    //       return;
    //     } else {
    //       if (this.error) {
    //         return;
    //       }
    //       var allowed_types = [
    //         "application/pdf",
    //         "application/vnd.openxmlformats-officedocument.wordprocessing",
    //         "application/msword",
    //         "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    //         "image/png",
    //         "image/jpg",
    //         "image/jpeg",
    //       ];
    //       var maxsize = 4 * 1024 * 1024;
    //       //let url = "https://smapi.sundryhrms.website/api/uploadapplicantdocument"
    //       // let url = "http://127.0.0.1:8000/api/uploadapplicantdocument"
    //       // let url = "https://sundrymarkets.website/api/uploadapplicantdocument"
    //       // let url = "https://sundryfoods.website/api/uploadapplicantdocument"
    //       let url = "https://api.cloudinary.com/v1_1/wajesmart/upload/";
    //       //Array to hold files that have been validated
    //       var validated = [];
    //       for (var i in this.$refs) {
    //         i = this.$refs[i];
    //         // console.log(i.files[0])
    //         if (allowed_types.includes(i.files[0].type)) {
    //           if (i.files[0].size < maxsize) {
    //             validated.push(i);
    //           } else {
    //             this.$swal.fire(
    //               "An error occured",
    //               "File size is large for " + i.name,
    //               "error",
    //             );
    //             this.isLoading = false;
    //             return false;
    //           }
    //         } else {
    //           this.$swal.fire(
    //             "An error occured",
    //             'Invalid File type for "' + i.name + '"',
    //             "error",
    //           );
    //           this.isLoading = false;
    //           return false;
    //         }
    //       }

    //       var config = {
    //         headers: {
    //           "Content-Type": "multipart/form-data",
    //         },
    //         timeout: 20000000000000000,
    //       };

    //       let count = 0;

    //       for (var file in validated) {
    //         //Set form data
    //         var fd = new FormData();
    //         this.application.applicant_id = this.applicant;
    //         let final = false;
    //         if (file == validated.length - 1) {
    //           fd.append("final_file", true);
    //           final = true;
    //         }
    //         // fd.append(validated[file].name, validated[file].files[0])
    //         fd.append("file", validated[file].files[0]);
    //         // fd.append("applicant_info", JSON.stringify(this.application))
    //         // fd.append("document_type", validated[file].name)
    //         fd.append("upload_preset", "sundrymarkets");
    //         //   fd.append("upload_preset", 'sundryfoods')
    //         fd.append("access_type", "anonymous");
    //         // console.dir(validated[file]);
    //         // console.log(fd);
    //         let name = validated[file].name;
    //         axios
    //           .post(url, fd, config)
    //           .then((response) => {
    //             // console.log(response)
    //             if (response.status == 200 || response.status == 201) {
    //               // setTimeout(() => {
    //               console.log(name);
    //               // this.$swal.fire("Success", "Document uploaded", 'success')
    //               this.application[name] = response.data.secure_url;
    //               if (++count == 6) {
    //                 this.submitForm();
    //                 // this.final_file = true;
    //               }
    //               // this.isLoading = false;
    //             }
    //           })
    //           .catch((error) => {
    //             // console.log(error)
    //             this.$swal.fire(
    //               "Success",
    //               "'An error occured processing your request.",
    //               "success",
    //             );
    //             this.isLoading = false;
    //           });
    //         // }, 2000)
    //       }
    //     }
    //   } catch (error) {
    //     this.$swal.fire(
    //       "Error",
    //       "Unable to verify your application. Please try again.",
    //       "error",
    //     );
    //     this.isLoading = false;
    //     return;
    //   }

    //   // this.submitForm();
    //   // this.isLoading = false;
    //   // this.$swal.fire("Success", "Form submitted. Please upload documents.", 'success')
    // },

    async submitFiles() {
      this.isLoading = true;

      try {
        const confirmResponse = await this.$socket.makePostRequest({
          what: "ConfirmApplication",
          showLoader: false,
          data: {
            emailaddress: this.application.emailaddress,
            joblistingid: this.application.joblistingid,
            company_id: this.application.company_id,
          },
        });

        console.log("confirmResponse:", confirmResponse);

        if (
          confirmResponse.type == "ConfirmApplication" &&
          confirmResponse.status == "true"
        ) {
          await this.proceedWithUpload();
        } else {
          this.$swal.fire(
            "Already Applied",
            confirmResponse.message ||
              "You have already applied for this position.",
            "error",
          );
          this.isLoading = false;
          return;
        }
      } catch (error) {
        console.log("Error confirming application:", error);
        

        this.$swal.fire("Error", error || "Unable to verify your application.", "error");
        this.isLoading = false;
        return;
      }
    },

    async proceedWithUpload() {
      if (this.error) return;

      var allowed_types = [
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.wordprocessing",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "image/png",
        "image/jpg",
        "image/jpeg",
      ];
      var maxsize = 4 * 1024 * 1024;
      let url = "https://api.cloudinary.com/v1_1/wajesmart/upload/";
      var validated = [];

      for (var i in this.$refs) {
        i = this.$refs[i];
        if (allowed_types.includes(i.files[0].type)) {
          if (i.files[0].size < maxsize) {
            validated.push(i);
          } else {
            this.$swal.fire(
              "An error occured",
              "File size is large for " + i.name,
              "error",
            );
            this.isLoading = false;
            return false;
          }
        } else {
          this.$swal.fire(
            "An error occured",
            'Invalid File type for "' + i.name + '"',
            "error",
          );
          this.isLoading = false;
          return false;
        }
      }

      var config = {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 20000000000000000,
      };

      let count = 0;

      for (var file in validated) {
        var fd = new FormData();
        this.application.applicant_id = this.applicant;

        if (file == validated.length - 1) {
          fd.append("final_file", true);
        }

        fd.append("file", validated[file].files[0]);
        fd.append("upload_preset", "sundrymarkets");
        fd.append("access_type", "anonymous");

        let name = validated[file].name;

        axios
          .post(url, fd, config)
          .then((response) => {
            if (response.status == 200 || response.status == 201) {
              this.application[name] = response.data.secure_url;
              if (++count == 6) {
                this.submitForm();
              }
            }
          })
          .catch((error) => {
            this.$swal.fire(
              "Error",
              "An error occured processing your request.",
              "error",
            );
            this.isLoading = false;
          });
      }
    },

    submitDone() {
      this.submitted_form = true;
    },
    async submitForm() {
      // this.isLoading = true;
      // let res;
      // let url1 = `https://sundryfoods.website/api/validatecandidate?firstname=${this.application.firstname}&lastname=${this.application.lastname}&emailaddress=${this.application.emailaddress}&company_id=${this.application.company_id}`
      // let url1 = `http://127.0.0.1:8000/api/validatecandidate?firstname=${this.application.firstname}&lastname=${this.application.lastname}&emailaddress=${this.application.emailaddress}&company_id=${this.application.company_id}`
      // let url2 = `https://sundrymarkets.website/api/validatecandidate?firstname=${this.application.firstname}&lastname=${this.application.lastname}&emailaddress=${this.application.emailaddress}&company_id=${this.application.company_id}`

      // fetch(url1, {
      // 	method: "get"
      // })
      // 	.then(response => response.json())
      // 	.then(data => {
      // 		if (data.status == true) {
      // 			res = true;
      // 		}
      // 		else {
      // 			fetch(url2, {
      // 				method: "get"
      // 			})
      // 				.then(response => response.json())
      // 				.then(data => {
      // 					if (data.status == true) {
      // 						res = true;
      // 					}
      // 					else {
      // 						res = false;
      // 					}
      // 				})
      // 		}
      // 	})
      // 	.then(() => {
      // 		if (res == true) {
      (function() {
        var input_fields = document.querySelectorAll(
          "#input-fields .form-control",
        );
        for (var input in input_fields) {
          if (typeof input_fields[input] == "object") {
            input_fields[input].disabled = true;
          }
        }
      })();

      if (this.application.cover_letter.length < 1) {
        this.application.no_cover_letter = true;
        return;
      }

      var apply = {
        what: "Apply",
        showLoader: false,
        data: this.application,
      };

      // setTimeout(() => {
      // this.$socket.makePostRequest(apply)
      // 	.then((response) => {
      // 		if (response.type == apply.what) {
      // 			if (response.status == "true") {
      // 				// this.$swal.fire("Success", "Form submitted. Please upload documents.", 'success')
      // 				this.$swal.fire("Success", "Form submitted. Successfully", 'success')
      // 				this.applicant = response.data.data.id
      // 				this.isLoading = false;
      // 				// this.submitFiles();
      // 				window.location.href = "/feedback"
      // 			}else{
      // 				this.$swal.fire("Error", response.message, 'error')
      // 				this.isLoading = false;
      // 				this.error = true;
      // 			}
      // 		}
      // 	})
      // 	.catch((error) => {
      // 		this.$swal.fire("Error", error.message || "'An error occured processing your request.", 'error')
      // 		// swal.fire('Error', 'An error occured processing your request.', 'error')
      // 		// console.log(error)
      // 		this.error = true;
      // 		this.isLoading = false;
      // 	})

      this.$socket
        .makePostRequest(apply)
        .then((response) => {
          if (response.type == apply.what) {
            if (response.status == "true") {
              this.$swal.fire(
                "Success",
                "Form submitted. Successfully",
                "success",
              );
              this.applicant = response.data.data.id;
              this.isLoading = false;
              window.location.href = "/feedback";
            } else {
              this.$swal.fire(
                "Error",
                response.message || "An error occurred",
                "error",
              );
              this.isLoading = false;
              this.error = true;
            }
          }
        })
        .catch((error) => {
          const msg =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            "An error occured processing your request.";
          this.$swal.fire("Error", msg, "error");
          this.error = true;
          this.isLoading = false;
        });
      // }, 500)
      // 	}
      // 	else {
      // 		swal.fire('Error', 'You have applied for a position within a year.', 'error')
      // 		this.isLoading = false;
      // 		this.error = true;
      // 	}
      // })
    },
  },
  components: {
    Menu,
    Footer,
    Summernote,
    Loading,
  },
};
</script>
